import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return (
      <div className='footerBar bottom-0'>
        ©2024 Ginkgo Bleu Leatherworks
      </div>
    )
  }
}
